export default __webpack_public_path__ + "static/media/flex-energy-logo.57859d1e.png";